import { Box, Heading, Section, Stack, Text } from "@vinomofo/components";
import {
  ClubCard,
  FaqPanel,
  GalleryPanel,
  QuotesPanel,
  SupportPanel,
} from "../../components/wine-clubs";
import { ImageDataLike, StaticImage, getImage } from "gatsby-plugin-image";
import { graphql, useStaticQuery } from "gatsby";

import { Layout } from "../../components/layout";
import SEO from "../../components/seo/seo";
import WineClubsProvider from "../../contexts/wine-clubs/provider";
import camelCase from "lodash.camelcase";
import { defaultStateForClub } from "../../contexts/wine-clubs/reducer";
import heroLogo from "../../images/wine-clubs/mofo-club-logo.svg";
import styled from "styled-components";
import { usePlanContext } from "../../hooks/wine-clubs/use-plan-context";

const ClubCards = () => {
  const { clubOptions } = usePlanContext();
  const data: {
    [key: string]: ImageDataLike;
  } = useStaticQuery(graphql`
    {
      blackMarketClub: file(
        relativePath: { eq: "wine-clubs/card-header-black-market-club.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData
        }
      }
      mofoClub: file(
        relativePath: { eq: "wine-clubs/card-header-the-mofo-club.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `);

  return (
    <Box
      display="grid"
      gridGap={4}
      gridAutoFlow={["row", "column"]}
      justifyContent="center"
    >
      {clubOptions.map((club, i) => {
        const defaultClub = defaultStateForClub(club);

        const image = getImage(data[camelCase(club.key)]);

        return (
          <ClubCard
            key={i}
            headerImage={image}
            club={defaultClub.club}
            variant={defaultClub.variant}
            frequency={defaultClub.frequency}
            preference={defaultClub.preference}
          />
        );
      })}
    </Box>
  );
};

const HeroContent = styled(Section)`
  grid-area: 1/1;
  position: relative;
  padding-top: 50px;
  padding-bottom: 100px;
  width: 100%;
`;

const HeroImage = styled(Box)`
  grid-area: 1/1;
  max-height: 780px;
`;

const WineClubsPage = (): JSX.Element => {
  return (
    <WineClubsProvider>
      <Layout>
        <SEO title="Wine Clubs" pathname="/wine-clubs/" type="page" />
        <Box display="grid" backgroundColor="black">
          <HeroImage opacity={[1, 1]}>
            <StaticImage
              style={{
                height: "100%",
              }}
              objectPosition="bottom 50%"
              // objectFit="cover"
              aspectRatio={28 / 13}
              layout="fullWidth"
              alt="Vinomofo Club"
              src={"../../images/wine-clubs/hero-home.jpeg"}
              formats={["auto", "webp", "avif"]}
            />
          </HeroImage>
          <HeroContent>
            <Box width="100%" maxWidth="840px">
              <Box mb="20px">
                <img src={heroLogo} alt="" />
              </Box>

              <Text color="white">
                Why join a wine club? Because you dream of a world where you
                always have good wine at home, without having to stress about
                it. Life’s busy enough – let us sort out your vino.
              </Text>
            </Box>
          </HeroContent>
        </Box>
        <Section py={60} backgroundColor="almostWhite">
          <Stack space={5}>
            <Stack space={3}>
              <Heading as="h2" variant="xl" textAlign="center">
                Wine made simple
              </Heading>
              <Box
                display="grid"
                gridGap={4}
                gridAutoFlow={["row", "column"]}
                justifyContent="center"
              >
                <Text fontSize={[1, 3, 4]}>1 / CHOOSE YOUR CLUB</Text>{" "}
                <Text fontSize={[1, 3, 4]}>2 / PERSONALISE YOUR PLAN</Text>{" "}
                <Text fontSize={[1, 3, 4]}>3 / BOOM! VINO SORTED</Text>
              </Box>
              <Text textAlign="center">
                There’s no lock-in contract and no bullsh*t. You just pick a
                club that works for your budget, personalise it to suit your
                tastes and decide how often you need your wine delivered. And
                before you ask, daily isn’t an option. Yet.
              </Text>
            </Stack>
            <ClubCards />
          </Stack>
        </Section>

        <GalleryPanel />
        <QuotesPanel />
        <FaqPanel />

        <Section py={60} backgroundColor="almostWhite">
          <Stack space={5}>
            <Stack space={3}>
              <Heading as="h2" variant="xl" textAlign="center">
                Right, so where were we?
              </Heading>
              <Text textAlign="center">
                WE MADE IT THIS FAR. SHALL WE MAKE IT OFFICIAL?
              </Text>
            </Stack>

            <ClubCards />
          </Stack>
        </Section>

        <SupportPanel />
      </Layout>
    </WineClubsProvider>
  );
};

export default WineClubsPage;
